module.exports = __webpack_public_path__ + "img/portfolio-art.6fdeff5d.png";